import script from "./RInput.vue?vue&type=script&setup=true&lang=js"
export * from "./RInput.vue?vue&type=script&setup=true&lang=js"

import "./RInput.vue?vue&type=style&index=0&id=3d00b162&lang=scss"

const __exports__ = script;

export default __exports__